import React from 'react';
import oasiscreche from '../assets/img/oasis/oasis-creche.jpg';
import crecheObjective1 from '../assets/img/oasis/crecheObjective.jpeg';
import crecheObjective2 from '../assets/img/oasis/creche-Objective2.jpeg';
import { CheckCheck } from 'lucide-react';
import { Helmet } from "react-helmet-async";

const OasisCrecheScreen = () => {

  const branches = [
    {
      location: 'Gogji Bagh, Srinagar, Kashmir',
      contact: ['9541133312', '8899887701'],
    },
    {
      location: 'Hakeem Bagh Rawalpora, OPP.GOVT.HR SEC. SCHOOL, Srinagar , Kashmir',
      contact: ['7006711920', '7006192942'],
    },
    {
      location: 'HIG COLONY Bemina, Srinagar, Kashmir',
      contact: ['7889326982', '7006964421'],
    },
    {
      location: 'Main Road Baba Demb, Srinagar, Kashmir',
      contact: ['9796731228', '8825041593'],
    },
    {
      location: 'Nowabad Sunjan, Near India cake house , Jammu',
      contact: ['8491828613', '9596164284'],
    }
  ];

  return (
    <>
      <Helmet>
        <title>Oasis Creche</title>
        <meta name="description" content=" Oasis Educational Institute" />
      </Helmet>
      <div className="font-sans bg-gray-50 text-gray-800 pt-4">

        <div className="relative h-96 flex items-center justify-center bg-cover bg-center mt-3" style={{ backgroundImage: "url('/images/creche-hero.jpg')" }}>
          <div className="absolute inset-0 bg-yellow-300 opacity-50"></div>
          <div className="relative text-center text-yellow-700">
            <h1 className="text-4xl font-bold mb-4 sm:mt-2 xs:mt-2">Welcome to Oasis Creche</h1>
            <p className="text-xl">Nurturing tiny seeds into magnificent trees</p>
          </div>
        </div>


        <div className="container mx-auto px-6 py-12">
          <div className="grid md:grid-cols-2 gap-8">
            <div>
              <h2 className="text-3xl font-bold mb-4">About Us</h2>
              <p className="text-gray-600 mb-4">
                Oasis is a Nursery network that spans across Srinagar, offering a comprehensive curriculum to children from the age of 18 months to 4 years. Our project-based, child-centric early childhood educational system ensures strong preparation for any school academic system.
              </p>
              <p className="text-gray-600">
                We provide a colourful and chirpy environment with fun-filled classroom activities, educational aids, and a play zone area with play stations.
              </p>
            </div>
            <div className="flex justify-end">
              <img src={oasiscreche} alt="About Creche" className="rounded-lg shadow-lg" />
            </div>
          </div>
        </div>

        {/* Mission and Vision Section */}
        <div className="bg-blue-50 py-12">
          <div className="container mx-auto px-6">
            <div className="grid md:grid-cols-2 gap-8">
              <div>
                <h2 className="text-3xl font-bold mb-4">Our Mission</h2>
                <p className="text-gray-600">
                  To foster a society of responsible citizens with progressive thinking, initiating positive change through quality education, virtuous thoughts, and a positive attitude.
                </p>
              </div>
              <div>
                <h2 className="text-3xl font-bold mb-4">Our Vision</h2>
                <p className="text-gray-600">
                  To help young minds grow and learn in a harmonious environment, resulting in the all-round development of children and making them active citizens of the nation.
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Features Section */}
        <div className="container mx-auto px-6 py-12">
          <h2 className="text-3xl font-bold text-center mb-8">Salient Features</h2>
          <div className="grid md:grid-cols-3 gap-6">
            {[
              "A project-based, child-centric early childhood educational system",
              "Strong preparation for any school academic system",
              "Adequate teacher-child ratio",
              "Qualified, experienced staff",
              "Theme-based learning",
              "Play zone area",
              "CCTV support",
              "Hygienic snacks & meals",
              "Islamic studies for moral values",
              "Centrally heated classrooms",
              "Indoor playroom",
              "Art & craft",
              "Social and emotional development",
              "Development of motor skills",
              "Learning resources: Montessori equipment",
              "Colourful & chirpy environment",
              "Fun-filled classroom activities",
              "Educational aids",
              "Feedback for parents",
              "Swimming pool",
              "Multiple city branches for convenient childcare",
            ].map((feature, index) => (
              <div key={index} className="bg-white p-6 rounded-lg shadow-md text-center">
                <p className="text-gray-700">{feature}</p>
              </div>
            ))}
          </div>
        </div>

        {/* Objectives Section */}
        <div className="bg-green-50 py-12">
          <div className="container mx-auto px-6">
            <h2 className="text-3xl font-bold text-center mb-8">Our Objectives</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              <div className="md:col-span-1">
                <p className="text-gray-600 mb-4 flex items-center gap-2">
                  <CheckCheck className="w-4 h-4 text-green-600" />
                  To provide a first-class standard of child care for all children.
                </p>
                <p className="text-gray-600 mb-4 flex items-center gap-2">
                  <CheckCheck className="w-4 h-4 text-green-600" />
                  To enhance physical, intellectual, communicative, creative, and emotional development through play-way methods.
                </p>
                <p className="text-gray-600 mb-4 flex items-center gap-2">
                  <CheckCheck className="w-7 h-4 text-green-600" />
                  To help young minds grow and learn in a harmonious environment, resulting in the all-round development of children and shaping them into active citizens of the nation.
                </p>
                <p className="text-gray-600 mb-4 flex items-center gap-2">
                  <CheckCheck className="w-4 h-4 text-green-600" />
                  To promote self-confidence in children and develop active and creative minds.
                </p>
                <p className="text-gray-600 mb-4 flex items-center gap-2">
                  <CheckCheck className="w-4 h-4 text-green-600" />
                  Empowering children to develop into disciplined leaders of the future with self-esteem.
                </p>
                <p className="text-gray-600 mb-4 flex items-center gap-2">
                  <CheckCheck className="w-4 h-4 text-green-600" />
                  To provide a child-centered education system focused on the growth and development of each child.
                </p>
                <p className="text-gray-600 mb-4 flex items-center gap-2">
                  <CheckCheck className="w-6 h-4 text-green-600" />
                  To nurture enthusiastic and inspirational teaching and learning within the context of a balanced curriculum imparted to every student.
                </p>
                <p className="text-gray-600 mb-4 flex  items-center gap-2">
                  <CheckCheck className="w-7 h-5 text-green-600" />
                  To channel the child's energy through recreational activities, encouraging participation in group discussions and activities, thereby developing communication and soft skills.
                </p>
                <p className="text-gray-600 flex items-center gap-2">
                  <CheckCheck className="w-4 h-4 text-green-600" />
                  To provide a strong and solid foundation for lifelong learning and growth.
                </p>
              </div>

              <div className="flex flex-col gap-6 items-center">
                <img
                  src={crecheObjective1}
                  alt="Objective 1"
                  className="rounded-lg shadow-lg w-full sm:w-[90%] md:w-[80%] lg:w-[60%] mx-auto"
                />
                <img
                  src={crecheObjective2}
                  alt="Objective 2"
                  className="rounded-lg shadow-lg w-full sm:w-[90%] md:w-[80%] lg:w-[60%] mx-auto"
                />
              </div>
            </div>
          </div>
        </div>

        {/* Admissions Section */}
        <div className="container mx-auto px-6 py-12">
          <h2 className="text-3xl font-bold text-center mb-8">Admissions</h2>
          <div className="text-center">
            <p className="text-gray-600 mb-4">
              Pre-School hours are 9:00 am to 3:00 pm during summers and 10:00 am to 4:00 pm during winters.
            </p>
            <p className="text-gray-600">
              To enroll your child, fill out a registration form and pay a non-refundable fee of Rs. 500/-. Registration is completed after verification of the child's date of birth certificate and photographs of the child and both parents.
            </p>
          </div>
        </div>

        {/* Branches Section */}
        <div className="container mx-auto px-6 py-12">
          <h2 className="text-3xl font-bold text-center mb-8">Our Branches</h2>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {branches.map((branch, index) => (
              <div key={index} className="bg-white p-6 rounded-lg shadow-md">
                <h3 className="text-xl font-semibold mb-4">{branch.location}</h3>
                <div className="text-gray-600">
                  {branch.contact.map((number, idx) => (
                    <p key={idx}>{number}</p>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default OasisCrecheScreen;